/** @jsxRuntime classic */
/** @jsx jsx */
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { jsx } from 'theme-ui';
import moment from 'moment';

import ActivityLoader from './ActivityLoader';
import ActivityPageWrap from './ActivityPageWrap';
import FeedEmptyState from './FeedEmptyState';
import Feed from './Feed';

import { getGlobalFeed, getToken } from '../../selectors';
import { shouldFetchFeed } from '../../ducks/feed';
import { ACTIVE_TAB_GLOBAL } from './constants';

export default function FeedGlobal() {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const token = useSelector(getToken);
  const feed = useSelector(getGlobalFeed());
  const items = feed.items;
  const wasRecentlyUpdated = moment()
    .subtract(45, 'seconds')
    .isBefore(feed.updated);

  useEffect(() => {
    if (!isLoading) {
      setIsLoading(true);
      shouldFetchFeed({ dispatch, token, friends: false })
        .then(() => setIsLoading(false))
        .catch(() => setIsLoading(false));
    }
  }, [feed.updated === undefined, wasRecentlyUpdated]);

  const noItems = items.length === 0;

  return (
    <ActivityPageWrap activeTab={ACTIVE_TAB_GLOBAL}>
      {isLoading && noItems && <ActivityLoader />}
      {!isLoading && noItems && <FeedEmptyState />}
      {!noItems && <Feed items={items} />}
    </ActivityPageWrap>
  );
}
